<template>
  <div class='pt-32'>

    <ContentWrapper>
      <div class='flex flex-col md:flex-row gap-12 items-center'>
        <div class='w-full md:w-2/5'>
          <img :src='about1' alt='Entegy' class='w-3/4 mx-auto h-auto object-contain' />
        </div>
        <div class='w-full md:w-3/5'>
          <div class='text-2xl font-headings'>Australian-owned excellence in event tech, for 25 years.</div>
          <div class='text-gray-500 mt-8'>
            In late 2000, Australian event tech innovators, Ian Apuli and Angus Hotchin, registered the company known today as Entegy - the name being a blend of their core values: energy, integrity, and strategy - to serve the events industry with leading edge web tools and top shelf print media.
          </div>
          <div class='text-gray-500 mt-8'>
            Since then Entegy has grown to become a global leader in event technology and the only Software-as-a-Service (SaaS) offering across the entire events industry, while remaining a 100% Australian-owned, investor-free company with a 100% focus on relentless event tech innovation.
          </div>
        </div>
        
      </div>
    </ContentWrapper>

    <ContentWrapper class='mt-32'>
      <div class='flex flex-col md:flex-row gap-12 items-center md:flex-row-reverse'>
        <div class='w-full md:w-2/5'>
          <img :src='about2' alt='Entegy' class='w-3/4 mx-auto h-auto object-contain' />
        </div>
        <div class='w-full md:w-3/5'>
          <div class='text-2xl font-headings'>Event capability so clever it created hundreds of skilled jobs.</div>
          <div class='text-gray-500 mt-8'>
            In 2011 the Entegy team executed a fusion of design and technology in the event space and took a pioneering step forward in building an all-in-one, self-managed event platform that could be easily managed internally to deliver a one-of-a-kind experience for attendees and exhibitors.     
          </div>
          <div class='text-gray-500 mt-8'>
            Event tech companies were established especially to partner with the Entegy platform, creating many hundreds of skilled jobs between them, and by 2016 the popularity of Entegy’s exceptional event experience enabled deployment of a game-changing global partner model.
          </div>
        </div>
        
      </div>
    </ContentWrapper>

    <ContentWrapper class='my-32'>
      <div class='flex flex-col md:flex-row gap-12 items-center'>
        <div class='w-full md:w-2/5'>
          <img :src='about3' alt='Entegy' class='w-3/4 mx-auto h-auto object-contain' />
        </div>
        <div class='w-full md:w-3/5'>
          <div class='text-2xl font-headings'>Now available to sign-up to DIY or work with a network of amazing partners around the world.</div>
          <div class='text-gray-500 mt-8'>
            Whatever type of event you want to host, however large or complex or nuanced the challenge is, if you empower your team, exhibitors and attendees with the Entegy platform, you’ll deliver a next-level experience at every touch point and a new benchmark of ROI for your stakeholders.
          </div>
          <div class='text-gray-500 mt-8'>
            No gimmicks, no fads, no short-term strategies. Just solid technology principles that have been proven time, after time, after time, designed by specialist event tech inventors to make life easier and more enjoyable for everyone involved, end-to-end.
          </div>
        </div>
        
      </div>
    </ContentWrapper>

    <Cta />

  </div>
</template>

<script setup>
import Pattern from '../components/Pattern.vue';
import PatternTransparent from '../components/PatternTransparent.vue';
import ContentWrapper from '@/components/Layouts/ContentWrapper.vue';
import Cta from '@/components/Blocks/Cta.vue';

import about1 from '@/images/accent/event-technology-innovation.svg';
import about2 from '@/images/accent/laptop-sprouting-life.svg';
import about3 from '@/images/accent/star-in-hand.svg';
// About page component
</script>


<style>
.stacked-linear {
  background:
    linear-gradient(217deg, #4f39f6, transparent 70.71%),
    linear-gradient(127deg, #7d38ff, transparent 70.71%),
    linear-gradient(336deg, #ff69b2, transparent 70.71%);
  background-size: 200% 200%;
  animation: gradientShift 10s ease infinite;
}

@keyframes gradientShift {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

.entegy-pill-large {  
  border-top-right-radius:48px;
  border-bottom-left-radius: 48px;
  border-top-left-radius: 8px;
  border-bottom-right-radius: 8px;
}

.entegy-pill-small {  
  border-top-right-radius:24px;
  border-bottom-left-radius: 24px;
  border-top-left-radius: 8px;
  border-bottom-right-radius: 8px;
}
</style>